export default "__VITE_ASSET__DvrDk1hJ__"